export default {
  root: {
    class: [
      'relative',

      // Flexbox & Alignment
      'inline-flex',
      'align-bottom',

      // Size
      'w-4 h-4',

      // Misc
      'cursor-pointer',
      'select-none',
    ],
  },
  box: ({ props, instance }) => ({
    class: [
      // Flexbox
      'flex justify-center items-center',

      // Size
      'w-4 h-4',

      // Shape
      'border-2',
      'rounded-full',

      // Transition
      'transition duration-200 ease-in-out',

      // Colors
      {
        'text-black':
          props.value !== props.modelValue &&
          props.value !== undefined &&
          !instance.$attrs['universal-item-search'],
        'text-blue-800':
          props.value !== props.modelValue &&
          props.value !== undefined &&
          instance.$attrs['universal-item-search'],
        'bg-primary-500': props.value !== props.modelValue && props.value !== undefined,
        'border-black':
          props.value !== props.modelValue &&
          props.value !== undefined &&
          !props.invalid &&
          !instance.$attrs['universal-item-search'],
        'border-blue-100':
          props.value !== props.modelValue &&
          props.value !== undefined &&
          !props.invalid &&
          instance.$attrs['universal-item-search'],
        'border-black':
          props.value == props.modelValue &&
          props.value !== undefined &&
          !instance.$attrs['universal-item-search'],
        'border-blue-100':
          props.value == props.modelValue &&
          props.value !== undefined &&
          instance.$attrs['universal-item-search'],
      },
      // Invalid State
      { 'border-red-500': props.invalid },

      // States
      {
        'peer-hover:border-primary-500': !props.disabled && !props.invalid,
        'peer-hover:border-primary-600 peer-hover:bg-primary-600':
          !props.disabled && props.value == props.modelValue && props.value !== undefined,
        'peer-focus-visible:border-primary-500 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-400/20':
          !props.disabled,
        'opacity-60 cursor-not-allowed': props.disabled,
      },
    ],
  }),
  input: ({ props }) => ({
    class: [
      'peer',

      // Size
      'w-full ',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded-md',
      'outline-none',

      // Misc
      'appearance-none',
      { 'cursor-pointer': !props.disabled },
      { 'cursor-not-allowed': props.disabled },
    ],
  }),
  icon: ({ props, instance }) => ({
    class: [
      'block',

      // Shape
      'rounded-full',

      // Size
      'w-2 h-2',

      // Colors
      { 'bg-black': !instance.$attrs['universal-item-search'] },
      { 'bg-blue-800': instance.$attrs['universal-item-search'] },

      // Conditions
      {
        'backface-hidden scale-10 invisible': props.value !== props.modelValue,
        'transform visible scale-[1.1]': props.value == props.modelValue,
      },

      // Transition
      'transition duration-200',
    ],
  }),
};
